import React from 'react';
import { number, string, func } from 'prop-types';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  onSelect: func.isRequired,
  onRemove: func.isRequired,
};

const StatisticsPresetsListItem = ({ id, title, onSelect, onRemove }) => (
  <li className="statistics-presets-list-item" onClick={() => onSelect(id)}>
    <span className="statistics-presets-item-name" title={title}>
      {title}
    </span>

    {id > 0 && (
      <button
        type="button"
        title="Remove"
        className="statistics-presets-item-remove"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          return onRemove(id);
        }}
      >
        <SVG
          src={`${STATIC_PATH}/img/action-icons/bin-icon-2.svg`}
          height="20"
          width="20"
          cacheRequests
        />
      </button>
    )}
  </li>
);

StatisticsPresetsListItem.propTypes = propTypes;

export default StatisticsPresetsListItem;
